<template>
    <time :title="secondary_time">{{main_time}}</time>
</template>

<script>

// example: <time-tz :item="time" field="time" />

export default {
  name: 'time-tz',
  props: {
    item: {required: true},
    field: { type: String, required: true }
  },
  computed: {
    time_type () { return this.$store.state.timezone_type },
    main_time () {
      // console.log('time_computed')
      const type = this.time_type || 'user' // user | local
      return this.getTimeFor(type)
    },
    secondary_time () {
      // console.log('time_computed')
      const type = (this.time_type || 'user') === 'user' ? 'local' : 'user' // reverse! vars: user | local
      return this.getTimeFor(type)
    }

  },
  methods: {
    getTimeFor (type) {
      const key = this.field + '_formatted_' + type
      if(_.get(this.item, key)) {
        const formatted = _.get(this.item, key);
        return formatted;
      }
      // if (!formatted) console.error('field', key, 'not defined')
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/globals/timeTz.vue